module.exports = __webpack_public_path__ + "static/media/logo.82c1baa6.png";